import { memo, useMemo } from "react";
// @ts-ignore
import Autolinker from "autolinker";
import { TextMessage } from "@/services/chat";
import styles from "./index.less";

type TextProps = {
  msg: TextMessage;
};

const Text = ({ msg }: TextProps) => {
  
  const processedContent = useMemo(() => {
    const content = msg.messageOutput || "";
    
    // 使用 Autolinker.js 处理URL链接
    return Autolinker.link(content, {
      // 只启用URL链接，禁用其他功能
      urls: true,
      email: true,
      phone: false,
      mention: false,
      hashtag: false,
      // 链接配置
      newWindow: true,
      stripPrefix: false,
      stripTrailingSlash: false,
      // 添加样式类
    //   className: 'chat-link',
      // 自定义链接属性
      // replaceFn: function(match: any) {
      //   if (match.getType() === 'url') {
      //     const tag = match.buildTag();
      //     tag.setAttr('target', '_blank');
      //     tag.setAttr('rel', 'noopener noreferrer');
      //     return tag;
      //   }
      //   return true;
      // }
    });
  }, [msg.messageOutput]);

  return (
    <div 
      className={styles["chat-text"]}
      dangerouslySetInnerHTML={{ __html: processedContent }}
    />
  );
};

export default memo(Text);
